/* LocationTypeRenderer.js */

"use strict";

//const _ = require("lodash");

class LocationTypeRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("locationtype-column");
        this._rootElem.component = this._model;

        this._icon = document.createElement("base-icon-gl");
        this._rootElem.appendChild(this._icon);

        this._registerListeners();
        this.render();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }
    _registerListeners() {
        this._model.on("LocationType", (this._onLocationType = this._onLocationType.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeAllListeners("LocationType");
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._updateIcon(this._model.getValue());
            resolve();
        });
        return prom;
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onLocationType(newVal) {
        this._updateIcon(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _updateIcon() {
        const { icon, title } = this._model.getIconData();
        this._icon.dataset.icon = icon;
        this._icon.setAttribute("title", title);
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = LocationTypeRenderer;
